import { render, staticRenderFns } from "./game_room_config.vue?vue&type=template&id=f805e0fc&scoped=true"
import script from "./game_room_config.vue?vue&type=script&lang=js"
export * from "./game_room_config.vue?vue&type=script&lang=js"
import style0 from "./game_room_config.vue?vue&type=style&index=0&id=f805e0fc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f805e0fc",
  null
  
)

export default component.exports